/** `/c/$companyId/review?family&status&item` — the review queue. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { WORK_ITEM_FAMILIES, WORK_ITEM_STATUSES } from "../api/codes";
import { QueueScreen } from "../queue/QueueScreen";

const search = z.object({
  family: z.enum(WORK_ITEM_FAMILIES).optional().catch(undefined),
  status: z.enum(WORK_ITEM_STATUSES).optional().catch(undefined),
  item: z.string().uuid().optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/c/$companyId/review")({
  validateSearch: (raw) => search.parse(raw),
  component: ReviewRoute,
});

function ReviewRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  const { family, status, item } = Route.useSearch();
  return <QueueScreen companyId={companyId} family={family} status={status} itemId={item} />;
}
